import api from './api';

export default {
  async getTransactionsInfo() {
    try {
      const response = await api.get('/withdraw-summary/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  },
  async getTableData() {
    try {
      const response = await api.get('/withdraws-aporte/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  }
};
